import gql from 'graphql-tag';

export const SITEINI_OPERATION_MOVE_RAW = `
  mutation ($input: SiteiniOperationMoveInput!){
    siteiniOperationCreateMove(input: $input) {
      id
      site
      country
    }
  }
`;

export const SITEINI_OPERATION_MOVE = gql`${SITEINI_OPERATION_MOVE_RAW}`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/siteini_operation/move.js